export * from './CourseGrouping';
export { default } from './CourseGrouping';
